import { displayTimeRangeTooltip, createSectionPutData } from './summary_dws';
import { calculateMarginLeftAfterResize, calculateMarginRightAfterResize, calculateFromAndToAfterResize, getTimelineGridCellSize, removeResizeClasses } from './summary_dws_resize';
import { dateToTimeString, isMobileBrowser } from './common';
import { sectionConfig } from './resizable_section_config';
// config object is global, need to make a copy exclusively for section resize
const dragAxisDirection = Object.freeze({
  left: "w",
  right: "e"
})

function handleSectionResize(event, ui) {
  const slotEl = $(ui.element);
  const parentEl = slotEl.parents(".slot.draggable");
  const slotId = slotEl.data('id');
  const slot = SlotMap[slotId];
  const axis = slotEl.data("ui-resizable").axis;
  const resizeGridWidth = $( ".section" ).resizable( "option", "grid" )[0];
  const rowWidth = $(event.target).parent(".sections-overlay").width();
  const {from, to} = calculateFromAndToAfterResize(slot, resizeGridWidth, ui, axis);

  if (axis === dragAxisDirection.left) {
    const relativeMarginLeft = calculateMarginLeftAfterResize(parseInt(slotEl.data("original-margin-left")), ui.position.left, rowWidth);
    slotEl.css("margin-left", `${relativeMarginLeft}%`);
  } else {
    const relativeMarginRight = calculateMarginRightAfterResize(parseInt(slotEl.data("original-margin-right")), ui.originalSize.width, ui.size.width, rowWidth);
    slotEl.css("margin-right", `${relativeMarginRight}%`);
  }
  displayTimeRangeTooltip(parentEl, dateToTimeString(from), dateToTimeString(to));
}

function handleSectionResizeStart(event, ui) {
  const gridCellSize = getTimelineGridCellSize();
  //Grid is set dynamically in start because the grid size may have changed.
  $(".section").resizable("option","grid", [gridCellSize, 0]);
  const dragElement = $(event.target);
  if ($(ui.element).data("ui-resizable").axis === dragAxisDirection.left) {
    const originalMarginLeft = dragElement.css("margin-left").split("px")[0];
    dragElement.data('original-margin-left', originalMarginLeft);
    disableBodyOnDrag(dragAxisDirection.left);
  } else {
    const originalMarginRight = dragElement.css("margin-right").split("px")[0];
    dragElement.data('original-margin-right', originalMarginRight);
    disableBodyOnDrag(dragAxisDirection.right)
  }
}

function handleSectionResizeStop(ui) {
  enableBodyOnDrag();
  const slotEl = $(ui.element);
  removeResizeClasses(slotEl.parents(".slot.draggable"));
  const slotId = slotEl.data('id');
  const slot = SlotMap[slotId];
  // Put back the temporary disabled section parent's draggable event
  const axis = slotEl.data("ui-resizable").axis;
  const resizeGridWidth = $(".section").resizable( "option", "grid" )[0];
  const {from, to} = calculateFromAndToAfterResize(slot, resizeGridWidth, ui, axis);

  sectionSubmitSummary(true, createSectionPutData(slot, from, to), slot.ID);
}

// This function temporarily disables the parent slot's drag event when section is being resized
function disableParentSlotDragEvent(elementDOM) {
  elementDOM.find(".ui-resizable-handle").on("mousedown", function(e) {
    $(".draggable-handler").removeClass("drag-handle");
    $(".sections-overlay").removeClass("drag-handle");
  });

  elementDOM.find(".ui-resizable-handle").on("mouseup", function(e) {
    $(".draggable-handler").addClass("drag-handle");
    $(".sections-overlay").addClass("drag-handle");
  });

  elementDOM.find(".ui-resizable-handle").click(function(e) {
    e.preventDefault();
    e.stopPropagation();
  });
}

function disableBodyOnDrag(direction = "col") {
  $("html").css({
    cursor: `${direction}-resize`,
  });
  $("body").css({
    pointerEvents: "none",
  });
}

function enableBodyOnDrag() {
  $("html").css({
    cursor: "auto",
  });
  $("body").css({
    pointerEvents: "auto",
  });
}

// initResizableOnSlot is used to make a new slot element resizable.
export function initResizableOnSection(slot) {
  if (slot.Sections) {
    slot.Sections.forEach(sectionId => {
      const newElDOM = $(`#slot-${sectionId}`);
      newElDOM.resizable(sectionConfig);
      disableParentSlotDragEvent(newElDOM);
    })
  }
}

export function initSectionResizable() {
  // Check if user is on mobile phone or not using browser detection
  if (isMobileBrowser()) {
    sectionConfig.autoHide = false;
  }

  sectionConfig.start = (event, ui) => handleSectionResizeStart(event, ui);
  sectionConfig.stop = (_, ui) => handleSectionResizeStop(ui);
  sectionConfig.resize = (event, ui) => handleSectionResize(event, ui);

  $(".section").resizable(sectionConfig);

  disableParentSlotDragEvent($(".section"));
}
